import { get } from "lodash";

interface IGQLQueryUpdateHelperProps {
  fetchMoreResult?: any;
  responseDataGetterString?: any;
}

export const GQLQueryUpdateHelper = (
  keys: string[],
  Getter: string[],
  props?: IGQLQueryUpdateHelperProps,
  obj = {}
) => {
  const { fetchMoreResult, responseDataGetterString } = props;
  if (!keys?.length) return obj;

  const key = keys.shift();
  let newObj = {};

  if (Array.isArray(Getter[key]))
    newObj = {
      [key]: [
        ...Getter[key],
        ...get(fetchMoreResult, responseDataGetterString, []),
      ],
    };
  else
    newObj = {
      [key]: {
        ...Getter[key],
        ...GQLQueryUpdateHelper(keys, Getter[key], props),
      },
    };

  return GQLQueryUpdateHelper(keys, Getter[key], props, newObj);
};
